import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    isDarkMode?: boolean;
    error?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
    { isDarkMode = false, error, className, rows = 3, ...rest },
    ref,
) {
    return (
        <textarea
            ref={ref}
            rows={rows}
            className={cn(
                'w-full text-[13px] px-3 py-2 rounded-md border transition-colors duration-150 resize-y',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:border-blue-500',
                'disabled:opacity-50 disabled:cursor-not-allowed',
                isDarkMode
                    ? 'bg-gray-900/40 border-gray-700 text-gray-100 placeholder:text-gray-500'
                    : 'bg-white border-gray-300 text-gray-900 placeholder:text-gray-400',
                error && 'border-red-500',
                className,
            )}
            {...rest}
        />
    );
});

export default Textarea;
